module.exports = __webpack_public_path__ + "img/2x-12.c7293ab4.png";